import type { FC } from 'react';
import { Clock } from '@/components/Clock';

const App: FC = () => {
  return (
    <div className="w-screen h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
      <Clock />
    </div>
  );
};

export default App;
